import styled from "styled-components";
import {MobileMenuHeaderDefaultBox} from "./mobile-menu-header.default.box";

export const MobileMenuHeaderSiBox = styled(MobileMenuHeaderDefaultBox)`
    background-color: ${props => props.theme.colors.brandPrimary};
`